import React from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import store from "../../../../store";
import { setRendererFormState } from "../../../../store/slices/commonSlice";
const PhoneNumber = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
}) => {
  let key = databaseKey ? databaseKey : displayLabelKey;

  let validationPattern = fieldEle?.["validation-pattern"]
    ? new RegExp(fieldEle["validation-pattern"])
    : /^[0-9+\-\s()]*$/;

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <input
          id={newElfromJSON}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          className="form-control mandatory"
          type="text"
          placeholder={fieldEle?.["display-placeholder"]}
          disabled={fieldEle?.["display-disabled"] === 1}
          name={key}
          required={fieldEle?.["display-required"] === 1}
          value={formState[key] || ""}
          maxLength={fieldEle?.["validation-maxlength"]}
          pattern={fieldEle?.["validation-pattern"]}
          // pattern="^\d{10}$"
          // onChange={(e) =>
          //   rootReducer.dispatch(setRendererFormState({ key, value: e.target.value }))
          // }
          onChange={(e) => {
            let inputValue = e.target.value;

            if (!validationPattern.test(inputValue)) {
              e.target.setCustomValidity("Please enter a valid phone number");
            } else {
              e.target.setCustomValidity("");
            }

            store.dispatch(
              setRendererFormState({ key, value: inputValue === "" ? null : inputValue })
            );
          }}
        />
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default PhoneNumber;
